/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setOpenToastAction,
  setConfirmDialogAction,
  setBasicDialogAction,
  setOpenCustomDailogAction,
  setDeviceCountAction,
  setSelectedNavListItemsAction,
  setPaginationModelAction,
  resetPaginationModelAction,
  setDataGridSortAction,
  setBasicPopoverAnchorElAction,
  setConfigAlertCountAction,
  setNotrificationCountAction,
  setTimeoutDialogAction,
  setActiveTabAction,
  setActiveMainTabAction,
  setAlarmsCountAction,
  setErrorMsgAction,
  setVersionDataAction,
  setIsLoadingStatusAction,
  setRowModesModelAction,
  setServerMaintenanceModeAction,
} from "./helperActions";
import { initialState } from "./helperInitialState";

const helpersSlice = createSlice({
  name: "helpers",
  initialState,
  reducers: {
    setOpenToast: setOpenToastAction,
    setConfirmDialog: setConfirmDialogAction,
    setBasicDialogOpenFor: setBasicDialogAction,
    setOpenCustomDailog: setOpenCustomDailogAction,
    setDeviceCount: setDeviceCountAction,
    setSelectedNavListItems: setSelectedNavListItemsAction,
    setPaginationModel: setPaginationModelAction,
    resetPaginationModel: resetPaginationModelAction,
    setDataGridSort: setDataGridSortAction,
    setBasicPopoverAnchorEl: setBasicPopoverAnchorElAction,
    setConfigAlertCount: setConfigAlertCountAction,
    setNotrificationCount: setNotrificationCountAction,
    setTimeoutDialog: setTimeoutDialogAction,
    setActiveTab: setActiveTabAction,
    setActiveMainTab: setActiveMainTabAction,
    setAlarmsCount: setAlarmsCountAction,
    setErrorMsg: setErrorMsgAction,
    setVersionData: setVersionDataAction,
    setIsLoadingStatus: setIsLoadingStatusAction,
    setRowModesModel: setRowModesModelAction,
    setServerMaintenanceMode: setServerMaintenanceModeAction,
  },
});

export const HelperReducers = helpersSlice.reducer;
export const {
  setOpenToast,
  setConfirmDialog,
  setBasicDialogOpenFor,
  setOpenCustomDailog,
  setDeviceCount,
  setSelectedNavListItems,
  setPaginationModel,
  resetPaginationModel,
  setDataGridSort,
  setBasicPopoverAnchorEl,
  setConfigAlertCount,
  setNotrificationCount,
  setTimeoutDialog,
  setActiveTab,
  setActiveMainTab,
  setAlarmsCount,
  setErrorMsg,
  setVersionData,
  setIsLoadingStatus,
  setRowModesModel,
  setServerMaintenanceMode,
} = helpersSlice.actions;
